import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';

import {AuthenticationService} from '../_services/index';

@Component({
    moduleId: module.id,
    templateUrl: 'login.component.html',
    styleUrls: ['login.component.css']
})

export class LoginComponent implements OnInit {
    model: any = {};
    loading = false;
    loginError = false;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private authenticationService: AuthenticationService) {
    }

    ngOnInit() {
        if (AuthenticationService.isLoggedIn()) {
            let returnUrl = this.route.snapshot.queryParams['returnUrl'] || this.authenticationService.getStartUrl();
            this.router.navigate([returnUrl]);
        }
    }

    login() {
        this.loading = true;
        this.authenticationService.login(this.model.username, this.model.password)
            .subscribe(
                () => {
                    this.loginError = false;
                    this.router.navigate([this.authenticationService.getStartUrl()]);
                },
                error => {
                    if (error.status === 401 || error.status === 403)
                    this.loginError = true;
                    this.loading = false;
                });
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/odQvAFzU/0/heba/118365/src/main/frontend/src/app/login/login.component.ts